<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              :pageId="pageId"
              :selectedMd="batchJobData.moduleCode"
              :selectedSmd="batchJobData.subModuleCode"
              :defaultMdOption="'select'"
              :defaultSmdOption="'select'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_ID')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.firstBatchJobId"
              maxlength="8"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="batchJobData.lastBatchJobId"
              maxlength="96"
              @keyup.enter="onIdDuplicationCheck"
              @keyup="onKeyUpInput($event, batchJobData, 'lastBatchJobId')"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              name="button"
              class="comm_btn_duplicate"
              @click="onIdDuplicationCheck"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.batchJobName"
              maxlength="25"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CYCL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.batchJobCycle"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IF_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.interfaceId"
              maxlength="100"
              @keyup="onKeyUpInput($event, batchJobData, 'interfaceId')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.beforeBatchJobId"
              maxlength="100"
              @keyup="onKeyUpInput($event, batchJobData, 'beforeBatchJobId')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_AF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="batchJobData.afterBatchJobId"
              maxlength="100"
              @keyup="onKeyUpInput($event, batchJobData, 'afterBatchJobId')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-program-select
              :selectedPrg="selectedPrg"
              readonly
              @selected="onSelectedPrg"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_PRTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="batchJobData.batchJobPracticeYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="batchJobData.batchJobPracticeYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-5" />
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model.trim="batchJobData.batchJobContent"
              name="name"
              rows="5"
              maxlength="1000"
              class="width100"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00004_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00004',
    },
  },
  data() {
    return {
      isIdDuplicationCheck: false,

      selectedPrg: {
        programName: '',
        programId: '',
      },

      searchFieldOldText: {},
      batchJobData: {
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        firstBatchJobId: 'BAT_',
        lastBatchJobId: '',
        batchJobId: '',
        batchJobName: '',
        batchJobCycle: '',
        interfaceId: '',
        beforeBatchJobId: '',
        afterBatchJobId: '',
        batchJobProgramId: '',
        batchJobProgramName: '',
        batchJobContent: '',
        batchJobPracticeYn: 'N',
      },
      orgBatchJobId: '',
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    // 내부 함수 기술
    // 이벤트 핸들러 기술, prefix on 적용
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onSelectedPrg() {
      this.batchJobData.batchJobProgramId = this.selectedPrg.programId;
      this.batchJobData.batchJobProgramName = this.selectedPrg.programName;
    },
    onClose() {
      this.$emit('close');
    },
    onSave() {
      this.save();
    },
    onIdDuplicationCheck() {
      this.idDuplicationCheck();
    },
    /** ***************************************************************************
      함수 영역
      ***************************************************************************** */
    idDuplicationCheck() {
      this.isIdDuplicationCheck = false;

      // set BatchJobId
      this.batchJobData.batchJobId = this.batchJobData.firstBatchJobId + this.batchJobData.lastBatchJobId;

      if (utils.isEmpty(this.batchJobData.lastBatchJobId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_BCJB_ID')));
        return false;
      }

      this.orgBatchJobId = this.batchJobData.batchJobId;
      http.request(this.pageId, 'DTS_CMS_00010', {
        query: {
          batchJobId: utils.trim(this.batchJobData.batchJobId),
        },
      }).then(res => {
        if (res.data.resultCode === '1') {
          this.isIdDuplicationCheck = true;
          const msg = utils.strFormat(this.$t('MSG_ALT_USE_PSBL'), this.$t('MSG_TXT_BCJB_ID'));
          utils.messageBox('success', msg);
        } else {
          utils.messageBox('error', this.$t('MSG_ALT_DUPLICATE_EXISTS'));
        }
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    save() {
      // set BatchJobId
      this.batchJobData.batchJobId = this.batchJobData.firstBatchJobId + this.batchJobData.lastBatchJobId;

      // form validation
      if (!this.formValidate(this.batchJobData)) {
        return false;
      }

      // searchBox -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.batchJobData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00013', { // dataservices reg.
          path: {
            'batch-job-id': utils.trim(this.batchJobData.batchJobId),
          },
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save');
          console.log(res);
        }).catch(error => {
          console.log(error);
        });
      });
      return true;
    },
    formValidate(formData) {
      if (utils.isEmpty(utils.trim(formData.moduleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.subModuleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.batchJobId))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_BCJB_ID')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.batchJobName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_BCJB_NM')));
        return false;
      }


      if (!this.isIdDuplicationCheck) {
        utils.messageBox('warning', this.$t('MSG_ALT_SELT_DPCT_CHK'));
        return false;
      }

      return true;
    },

    onKeyUpInput(event, obj, sCol) {
      if (utils.isEqual(sCol, 'lastBatchJobId')) {
        this.isIdDuplicationCheck = false;
      }
      console.log(this.isIdDuplicationCheck);
      if (event.key !== 13) {
        const searchFieldNewText = event.target.value;

        if (utils.isExistSpecialChar(searchFieldNewText)) {
          utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
            const has = Object.prototype.hasOwnProperty;
            if (has.call(obj[sCol], 'key')) {
            // eslint-disable-next-line no-param-reassign
              obj[sCol].key = this.searchFieldOldText[sCol];
            } else {
            obj[sCol] = this.searchFieldOldText[sCol]; // eslint-disable-line
            }
          });
        } else {
          this.searchFieldOldText[sCol] = searchFieldNewText; // eslint-disable-line
        }

        if (utils.isEqual(sCol, 'lastBatchJobId')
            && this.orgBatchJobId !== this.batchJobData.firstBatchJobId + searchFieldNewText) {
          this.isIdDuplicationCheck = false;
        }
      }
    },
  },
};
</script>
<style scoped>
</style>
